export default __webpack_public_path__ + "static/media/instagramLogo.fe162246.svg";